/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, names: NonNullable<unknown> }} Project_Paused_Spaces_DescriptionInputs */



/**
* | output |
* | --- |
* | "{count} linked space(s) are paused: {names}. AI responses in this project will not use them until they are reactivated." |
*
* @param {Project_Paused_Spaces_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_paused_spaces_description = /** @type {((inputs: Project_Paused_Spaces_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Paused_Spaces_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} verknüpfte(r) Space(s) sind pausiert: ${i?.names}. KI-Antworten in diesem Projekt nutzen sie nicht, bis sie wieder aktiviert werden.`)
	return /** @type {LocalizedString} */ (`${i?.count} linked space(s) are paused: ${i?.names}. AI responses in this project will not use them until they are reactivated.`)
});